/* lp1 | SB Wood Comparison LP — evergreen countdown (per visitor, loops). */
(function () {
  'use strict';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function initCountdown(scope) {
    var els = (scope || document).querySelectorAll('[data-lp1-countdown]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.lp1Init === '1') return;
      el.dataset.lp1Init = '1';

      var hours = parseFloat(el.getAttribute('data-hours')) || 24;
      var key = 'lp1sb_countdown_end';
      var end = 0;
      try { end = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) { /* storage blocked */ }

      var hEl = el.querySelector('[data-unit="h"]');
      var mEl = el.querySelector('[data-unit="m"]');
      var sEl = el.querySelector('[data-unit="s"]');
      if (!hEl || !mEl || !sEl) return;

      function reset() {
        end = Date.now() + hours * 3600000;
        try { localStorage.setItem(key, String(end)); } catch (e) { /* storage blocked */ }
      }

      if (!end || end - Date.now() > hours * 3600000) reset();

      function tick() {
        var d = end - Date.now();
        if (d <= 0) { reset(); d = end - Date.now(); }
        hEl.textContent = pad(Math.floor(d / 3600000));
        mEl.textContent = pad(Math.floor((d % 3600000) / 60000));
        sEl.textContent = pad(Math.floor((d % 60000) / 1000));
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCountdown(document); });
  } else {
    initCountdown(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initCountdown(e.target); });
})();
